import { loadColorBasketsForJigsaw } from "../../../pages/puzzles/jigsaw/JigsawColorBasketPlayService";
import {
    RECORDING_CONTENT_GRID,
    RECORDING_CONTENT_JIGSAW_ID,
    RECORDING_CONTENT_STORY_ID,
} from "../recordingContentPuzzle";
import { loadScreenshotJigsaw } from "./api";

/**
 * Story, template and color baskets for the pinned Color Basket capture puzzle.
 * Read-only: no play or basket session is created.
 */
export async function loadColorBasketDemoPuzzle() {
    const { group, template } = await loadScreenshotJigsaw({
        storyId: RECORDING_CONTENT_STORY_ID,
        expectedGrid: RECORDING_CONTENT_GRID,
    });
    const resolved = template?.id ? template : { id: RECORDING_CONTENT_JIGSAW_ID };
    const baskets = await loadColorBasketsForJigsaw(resolved.id);
    if (baskets.length === 0) {
        throw new Error("This puzzle has no color baskets to show");
    }
    return { story: group?.story ?? null, template: resolved, baskets };
}
